import { createApiCall, MethodType, URI } from "../Api";
import { VerifyResetPasswordTokenData } from "models/verifyResetPasswordToken";

export const verifyResetToken = (payload: VerifyResetPasswordTokenData) => {
  return createApiCall(MethodType.GET, URI.AUTH.VERIFY_RESET_TOKEN, payload);
};
